// src/pages/MaintenancePage.js

import React from 'react';
import { Box, Container, Typography, Button, Stack, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import IGDLogo from '../assets/IGD_wordmark.png';
const MotionBox = motion(Box);

const MaintenancePage = () => {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 2,
                py: 6,
                background: `
          radial-gradient(circle at top, rgba(216,153,54,0.12), transparent 30%),
          linear-gradient(180deg, #0f241b 0%, #193e2d 45%, #0d1f17 100%)
        `,
            }}
        >
            <Container maxWidth="md">
                <MotionBox
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <Paper
                        elevation={0}
                        sx={{
                            borderRadius: 5,
                            border: '1px solid rgba(216,153,54,0.35)',
                            background: 'rgba(25, 62, 45, 0.92)',
                            backdropFilter: 'blur(8px)',
                            boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
                            px: { xs: 3, sm: 5, md: 8 },
                            py: { xs: 5, sm: 6, md: 8 },
                            textAlign: 'center',
                            color: '#f5f1e8',
                        }}
                    >
                        {/* Logo */}
                        <Box
                            component="img"
                            src={IGDLogo}
                            alt="Indy Golf Den"
                            sx={{
                                width: { xs: 180, sm: 220, md: 260 },
                                mb: 3,
                            }}
                        />

                        {/* Gold accent */}
                        <Box
                            sx={{
                                width: 80,
                                height: 3,
                                borderRadius: 999,
                                mx: 'auto',
                                mb: 3,
                                background:
                                    'linear-gradient(90deg, #d89936, #f0c061, #d89936)',
                            }}
                        />

                        {/* Headline */}
                        <Typography
                            sx={{
                                fontFamily: 'lulo-one, sans-serif',
                                fontSize: { xs: '1.8rem', sm: '2.6rem', md: '3.2rem' },
                                letterSpacing: '0.1em',
                                textTransform: 'uppercase',
                                mb: 2,
                                lineHeight: 1.2,
                            }}
                        >
                            Temporarily
                            <Box
                                component="span"
                                sx={{
                                    display: 'block',
                                    color: '#d89936',
                                    mt: 1,
                                }}
                            >
                                Closed
                            </Box>
                        </Typography>

                        {/* Body */}
                        <Typography
                            sx={{
                                fontFamily: 'Roboto, sans-serif',
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                maxWidth: 640,
                                mx: 'auto',
                                mb: 2,
                                color: 'rgba(245, 241, 232, 0.9)',
                                lineHeight: 1.7,
                            }}
                        >
                            Indy Golf Den is temporarily closed for maintenance, and online
                            reservations are currently unavailable.
                        </Typography>

                        <Typography
                            sx={{
                                fontFamily: 'Roboto, sans-serif',
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                maxWidth: 620,
                                mx: 'auto',
                                mb: 4,
                                color: 'rgba(245, 241, 232, 0.75)',
                                lineHeight: 1.7,
                            }}
                        >
                            We plan to reopen and resume bookings beginning{' '}
                            <Box
                                component="span"
                                sx={{
                                    color: '#d89936',
                                    fontWeight: 700,
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                September 30th.
                            </Box>{' '}
                            We appreciate your patience and look forward to welcoming you
                            back to the Den soon.
                        </Typography>

                        {/* CTA */}
                        <Stack direction="row" justifyContent="center">
                            <Button
                                variant="contained"
                                size="large"
                                href="mailto:info@indygolfden.com"
                                sx={{
                                    px: 4,
                                    py: 1.3,
                                    borderRadius: 999,
                                    fontFamily: 'Roboto, sans-serif',
                                    fontWeight: 700,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.08em',
                                    backgroundColor: '#d89936',
                                    color: '#0f241b',
                                    '&:hover': {
                                        backgroundColor: '#e0a94a',
                                    },
                                }}
                            >
                                Contact Us
                            </Button>
                        </Stack>

                        <Typography
                            sx={{
                                mt: 4,
                                fontFamily: 'Roboto, sans-serif',
                                fontSize: '0.75rem',
                                color: 'rgba(245, 241, 232, 0.6)',
                                letterSpacing: '0.06em',
                                textTransform: 'uppercase',
                            }}
                        >
                            Thanks for your understanding
                        </Typography>
                    </Paper>
                </MotionBox>
            </Container>
        </Box>
    );
};

export default MaintenancePage;